import { useMutation } from '@tanstack/react-query';
import type { repository } from '@/types';
import type { ScmProviderId } from '@/types/scm-provider';
import { scmPost } from './scmClient';

interface repositoryRes {
  success: boolean;
  statusCode: number;
  message: string;
  data: {
    count: number;
    value: repository[];
  };
}

interface RequestBody {
  provider: ScmProviderId;
  body: {
    organization: string;
    project: string;
  };
  requesterToken: {
    patToken: string;
  };
}

export const getRepositoryDetails = ({
  provider,
  body,
  requesterToken,
}: RequestBody): Promise<repositoryRes> => {
  return scmPost(provider, '/api/scm/repositories', requesterToken.patToken, body);
};

export const useRepositoryDetail = ({ provider, body, requesterToken }: RequestBody) => {
  const res = useMutation({
    mutationFn: () => getRepositoryDetails({ provider, body, requesterToken }),
  });

  return {
    repoData: res.data,
    repoPending: res.isPending,
    repoError: res.error,
    repoStatus: res.status,
    mutate: res.mutate,
  };
};
